import dayjs from 'dayjs'

export const isDateToday = (date: Date) => {
    const today = new Date()

    return isSameDate(date, today)
}

export const isSameDate = (date: Date, checkDate: Date) => dayjs(date).isSame(dayjs(checkDate), 'day')
